/**
 * A simple type for representing one or more entries of a given type.
 */
export type Many<T> = T | ReadonlyArray<T>;
